/**
 * Fn to recursively remove all properties with null values from object
 * @param obj containing null values
 */
export const removeNulls = (obj: any) => {
	Object.entries(obj).forEach(([key, val]) => {
		if (val && typeof val === 'object') removeNulls(val);
		else if (val === null) delete obj[key];
	});
	return obj;
};
